'use client'

import { useEffect } from 'react'

import { AMP_EVENT_NAME, trackAmpEvent } from '@/libs/configs/amplitude'
import useGetParams from '@/libs/hooks/use-get-params'

export default function TrackClickNotification() {
  const { notification_title } = useGetParams()

  useEffect(() => {
    if (notification_title) {
      trackAmpEvent(AMP_EVENT_NAME.CLICK_PUSH_NOTIFICATION, {
        'Notification Title': notification_title,
      })
    }
  }, [notification_title])

  return null
}
